import { useMemo } from 'react';

import { useAbility } from '@/hooks/useAbility';
import { Action, Subject } from '@/modules/api/backend';

export function useIsAdmin() {
  const { ability } = useAbility();

  return useMemo(() => ability?.can(Action.MANAGE, Subject.All) ?? false, [ability]);
}
